import {
   Box,
   FormControl,
   Grid,
   InputLabel,
   Select,
   MenuItem,
   Button,
   TextField,
} from "@mui/material";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import React, { useEffect } from "react";
import MultipleSelect from "./MultipleSelect";
import SharedComponent from "./SharedComponent";
import { useDispatch, useSelector } from "react-redux";
import {
   getCloneDates,
   getCountryIDString,
   getValidityDates,
   periodTypes,
   sizes,
} from "./quotaCopyUtils";
import {
   getQuotaDetails,
   getSourcePeriods,
   getTargetPeriods,
   getUserCountries,
   setState,
} from "./quotaCopySlice";
import MultiSelectCountry from "./MultiSelectCountry";

const selectHeight = sizes.h35;
const selectWidth = sizes.w250;

export default function Form() {
   const dispatch = useDispatch();
   const state = useSelector((store) => store.quotaCopy);
   const {
      selectedPeriodType,
      selectedSourcePeriod,
      selectedTargetPeriod,
      sourcePeriods,
      targetPeriods,
      selectedCountries,
      countries,
      searchText,
      quotaDetailsTable,
      quotaDetailsTableCopy,
   } = state;

   useEffect(() => {
      if (selectedPeriodType !== "") {
         dispatch(getTargetPeriods({ periodType: selectedPeriodType }));
         dispatch(getSourcePeriods({ periodType: selectedPeriodType }));
      }
   }, [selectedPeriodType]);

   useEffect(() => {
      searchScenarioName(searchText);
   }, [searchText]);

   function setPeriodType(event) {
      const type = event.target.value;
      dispatch(setState("selectedPeriodType", type));
      dispatch(setState("selectedSourcePeriod", ""));
      dispatch(setState("selectedTargetPeriod", ""));
   }

   function setSourcePeriod(event) {
      const period = event.target.value;
      dispatch(setState("selectedSourcePeriod", period));
   }

   function setTargetPeriod(event) {
      const period = event.target.value;
      dispatch(setState("selectedTargetPeriod", period));
   }

   function setSearchText(event) {
      let text = event.target.value;
      text = text.toLowerCase();
      dispatch(setState("searchText", text));
   }

   function searchScenarioName(text) {
      if (text === "") {
         dispatch(setState("quotaDetailsTable", quotaDetailsTableCopy));
         return;
      }
      const updatedList = quotaDetailsTableCopy.rows.filter((item) =>
         item.scenarioName.toLowerCase().includes(text)
      );
      //if (updatedList.length > 0) {
         dispatch(setState("quotaDetailsTable", { rows: updatedList }));   
     // }
   }


   // function searchScenarioName(text) {
   //    const searchText = text.trim().toLowerCase();
    
   //    // Always preserve the full table structure
   //    const updatedTable = { ...quotaDetailsTableCopy };
    
   //    if (searchText === "") {
   //      dispatch(setState("quotaDetailsTable", updatedTable));
   //      return;
   //    }
    
   //    const filteredRows = quotaDetailsTableCopy.rows.filter((item) =>
   //      item.scenarioName?.toLowerCase().includes(searchText)
   //    );
    
   //    updatedTable.rows = filteredRows;
    
   //    dispatch(setState("quotaDetailsTable", updatedTable));
   //  }
    

	const showMessage = (message, severity) => {
		dispatch(setState("isInfoMsg", message));
		dispatch(setState("isInfo", true));
	};   

   function search() {
      dispatch(setState("quotaDetailsTable", null));
      dispatch(setState("detailQuotaTable",null));
      if(selectedCountries === undefined || selectedCountries.length === 0) {
         showMessage("Please select a country", "info");
      }
      else if(selectedPeriodType===null || selectedPeriodType===""){
         showMessage("Please select a period type", "info");
      }
      else if(selectedSourcePeriod===null || selectedSourcePeriod===""){
         showMessage("Please select  source period", "info");
      }
      else if(selectedTargetPeriod===null || selectedTargetPeriod===""){
         showMessage("Please select  target period", "info");
      }

      else{

      dispatch(setState("tableColChecked", false));
      const idList = getCountryIDString(selectedCountries, countries);
      const { validityStartDate, validityEndDate } = getValidityDates(
         targetPeriods,
         selectedTargetPeriod
      );
      const { cloneStartDate, cloneEndDate } = getCloneDates(
         sourcePeriods,
         selectedSourcePeriod
      );
      const obj = {
         countryIDList: idList,
         periodType: selectedPeriodType,
         validityStartDate,
         validityEndDate,
         cloneStartDate,
         cloneEndDate,
         searchText,
      };
      dispatch(getQuotaDetails(obj));
   }
   }

   return (
      <Box>
         <Grid container spacing={2} sx={{ mt: 2 }}>
            <Grid item sm={6} md={4} lg={2.5}>
               <MultiSelectCountry />
            </Grid>

            <Grid item sm={6} md={4} lg={2}>
               <FormControl>
                  <InputLabel>Period Type</InputLabel>
                  <Select
                     value={selectedPeriodType}
                     label="Period Type"
                     sx={{
                        height: selectHeight,
                        width: selectWidth,
                        color: "black.main",
                        mt: 1,
                     }}
                     onChange={setPeriodType}
                  >
                     {periodTypes.map((type, index) => {
                        return (
                           <MenuItem key={index} value={type}>
                              {type}
                           </MenuItem>
                        );
                     })}
                  </Select>
               </FormControl>
            </Grid>

            <Grid item sm={6} md={4} lg={2}>
               <FormControl>
                  <InputLabel>Source Period</InputLabel>
                  <Select
                     value={selectedSourcePeriod}
                     label="Source Period"
                     sx={{
                        height: selectHeight,
                        width: selectWidth,
                        color: "black.main",
                        mt: 1,
                     }}
                     onChange={setSourcePeriod}
                  >
                     {sourcePeriods.map((period, index) => {
                        return (
                           <MenuItem key={index} value={period.displayDate}>
                              {period.displayDate}
                           </MenuItem>
                        );
                     })}
                  </Select>
               </FormControl>
            </Grid>

            <Grid item sm={6} md={4} lg={2}>
               <FormControl>
                  <InputLabel>Target Period</InputLabel>
                  <Select
                     value={selectedTargetPeriod}
                     label="Target Period"
                     sx={{
                        height: selectHeight,
                        width: selectWidth,
                        color: "black.main",
                        mt: 1,
                     }}
                     onChange={setTargetPeriod}
                  >
                     {targetPeriods.map((period, index) => {
                        return (
                           <MenuItem key={index} value={period.displayDate}>
                              {period.displayDate}
                           </MenuItem>
                        );
                     })}
                  </Select>
               </FormControl>
            </Grid>

            {/* {quotaDetailsTable !== null &&
            quotaDetailsTable.rows.length !== 0 ? ( */}
               <Grid item sm={2}>
                  <TextField
                     id="outlined-controlled"
                     label="Search Scenario Name"
                     value={searchText}
                     onChange={setSearchText}
                  />
               </Grid>
            {/* // ) : (
            //    ""
            // )} */}

            <Grid item sm={6} md={4} lg={1}>
               <Button
                  startIcon={<ManageSearchIcon />}
                  sx={{
                     bgcolor: "darkred.light",
                     color: "white.main",
                     textTransform: "none",
                     fontWeight: "bold",
                     "&:hover": {
                        bgcolor: "darkred.main",
                     },
                  }}
                  onClick={search}
               >
                  Search
               </Button>
            </Grid>
         </Grid>
         <Box sx={{ mt: 2 }}>
            <strong>Previous Total Quota: </strong>Basis period selected in “Target Period”
            dropdown, displays previous period quota. <br/> <strong>Initial Quota & Total
            Quota: </strong>Displays quota values based on selection in “Source Period”
            dropdown (Once Copy/Submit quota action is performed).
         </Box>
      </Box>
   );
}
